var map = {
	"./add-blue.png": 69,
	"./archive.svg": 68,
	"./blue-arrow-left.svg": 97,
	"./blue-arrow-right.svg": 96,
	"./cancel-blue.svg": 37,
	"./cancel-grey.svg": 67,
	"./chevron.png": 95,
	"./doc.svg": 94,
	"./docx.svg": 93,
	"./download-icon.png": 70,
	"./information-grey.svg": 47,
	"./pdf.svg": 92,
	"./return-icon.svg": 91,
	"./shopping-trolley.png": 90,
	"./supermarket-basket.png": 349,
	"./toggle-sidebar.png": 89,
	"./warning-rd.svg": 88,
	"./white-arrow-left.svg": 87,
	"./white-arrow-right.svg": 86,
	"./zip.svg": 85
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	var module = __webpack_require__(id);
	return module;
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error('Cannot find module "' + req + '".');
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 350;